import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { IconFooter } from 'cpnl-common';
import { fetchIconFooter } from './IconFooterSlice';
import { IconFooterContentSelector } from './IconFooterContentSelector';

export function useIconFooter(): AbstractContentState<IconFooter> {
    return useCmsContent(fetchIconFooter, IconFooterContentSelector);
}
